<template lang="pug">
  section.section
    loading(v-if="loading")
    .container(v-if="!loading")
      .columns
        .colomn
          f-storage-image.image(:path="model.properties.thumbnailPath + '_s_256_____thumb.png'")
          .content
            h1.title {{ model.properties.name }}
            h5.title(v-if="model.properties.birthdate") วันเกิด: {{ $textHelper.toThaiDate(model.properties.birthdate) }}
            description(v-model="model.properties.description")
            media(:media="model.properties.files")
</template>

<script>
import Node from '@/models/node'
import FStorageImage from '@/components/FStorageImage'
import Loading from '@/components/Loading'
import Description from '@/components/Description'
import Media from '@/components/Media'
export default {
  components: {
    FStorageImage,
    Description,
    Loading,
    Media
  },
  data () {
    return {
      loading: true,
      model: null
    }
  },
  mounted () {
    const id = parseInt(this.$route.params.id)
    if (id) {
      this.load(id)
    }
  },
  methods: {
    load (id) {
      Node.get(id)
        .then((model) => {
          this.model = model
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .colomn {
    overflow: hidden;
  }
}
.image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 20px;
  overflow: hidden;
}
.title {
  color: #ddd;
  margin: 0;
}
h1.title {
  font-size: 30px;
  margin-bottom: 10px;
}
h5.title {
  font-size: 14px;
}

.files {
}

</style>



// WEBPACK FOOTER //
// src/pages/person/Detail.vue